import React from "react";

export const InfoItem = ({ label }) => {
  return (
    <div className="tw-rounded-[6px] tw-bg-[linear-gradient(125deg,#fdf6db_9.9%,#fefeef_45.45%,#fdf9db_81.01%)] tw-px-[16px] tw-py-[8px] tw-text-[#93871a] tw-text-[0.75rem] tw-leading-[17px] tw-tracking-[0.24px]">
      {label}
    </div>
  );
};
